var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 52.5,
    viewBox: "0 0 79 52.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-356.344 -43.663)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    stroke: "#9dbafc",
    d: "M6.025,0h65.95A6.025,6.025,0,0,1,78,6.025V38.168a6.025,6.025,0,0,1-6.025,6.025H6.024A6.024,6.024,0,0,1,0,38.169V6.025A6.025,6.025,0,0,1,6.025,0Z",
    transform: "translate(356.844 51.469)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.068 43.663)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9dbafc",
    d: "M419.341,51.469h-25.55l1.4-7.806h22.75Z",
    transform: "translate(-393.791 -43.663)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.408 47.138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.585 8.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#878f93",
    width: 10.879,
    height: 4.605
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605,
    transform: "translate(1.455)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.698,
    height: 4.605,
    transform: "translate(1.454)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605,
    transform: "translate(1.454)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c1c7c9",
    width: 0.697,
    height: 4.605,
    transform: "translate(1.455)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#6b98ff",
    d: "M1.865,0h9.863a1.865,1.865,0,0,1,1.865,1.865V5.572a1.862,1.862,0,0,1-1.862,1.862H1.862A1.862,1.862,0,0,1,0,5.572V1.865A1.865,1.865,0,0,1,1.865,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393e56",
    d: "M415.047,54.493a.888.888,0,0,1-.885.885h-8.754a.889.889,0,0,1-.886-.885V51.219a.887.887,0,0,1,.886-.883h8.754a.886.886,0,0,1,.885.883Z",
    transform: "translate(-402.988 -49.14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(356.844 57.674)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.982)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#9dbafc",
    width: 78,
    height: 26.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#769bef",
    d: "M363.411,75.663h-6.567v19.25h6.567a4.213,4.213,0,0,0,4.2-4.2V79.863A4.213,4.213,0,0,0,363.411,75.663Z",
    transform: "translate(-356.844 -75.663)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#769bef",
    d: "M455.9,75.663h6.567v19.25H455.9a4.213,4.213,0,0,1-4.2-4.2V79.863A4.212,4.212,0,0,1,455.9,75.663Z",
    transform: "translate(-384.576 -75.663)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.614)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#d1dbf3",
    cx: 17.538,
    cy: 17.538,
    r: 17.538
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.921 3.92)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393e56",
    d: "M420.038,84.193A13.618,13.618,0,1,1,406.42,70.575,13.619,13.619,0,0,1,420.038,84.193Z",
    transform: "translate(-392.802 -70.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4c5472",
    cx: 12.223,
    cy: 12.223,
    r: 12.223,
    transform: "translate(1.394 1.395)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393e56",
    d: "M418.441,85.391a10.823,10.823,0,1,1-10.824-10.823A10.825,10.825,0,0,1,418.441,85.391Z",
    transform: "translate(-394 -71.773)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141923",
    d: "M415.078,87.911a4.941,4.941,0,1,1-4.94-4.941A4.941,4.941,0,0,1,415.078,87.911Z",
    transform: "translate(-396.521 -74.294)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M420.687,80.843a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,420.687,80.843Z",
    transform: "translate(-395.806 -69.015)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M422.907,88.34a.879.879,0,1,1-1.233.16A.881.881,0,0,1,422.907,88.34Z",
    transform: "translate(-18.96 -13.901)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.244 48.196)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#263238",
    strokeWidth: "0.2px",
    stroke: "#9dbafc",
    width: 13.207,
    height: 3.343
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.97 0.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.79,
    height: 1.975
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.79,
    height: 1.975,
    transform: "translate(1.747)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.491)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.792,
    height: 1.975
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.792,
    height: 1.975,
    transform: "translate(1.747)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.792,
    height: 1.975
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.79,
    height: 1.975,
    transform: "translate(1.747)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 0.79,
    height: 1.975,
    transform: "translate(3.493)"
  })))), /*#__PURE__*/React.createElement("rect", {
    fill: "#393e56",
    width: 8.444,
    height: 2.659,
    transform: "translate(0 0.684)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraicon);
export default __webpack_public_path__ + "static/media/cameraicon.5fdd30a4.svg";
export { ForwardRef as ReactComponent };